import * as React from 'react';

function Home() {
  return <div>Bem-vindo ao Pepper! </div>;
}

export default Home;
